module.exports = __webpack_public_path__ + "media/application/images/features/sales-channels-2200-d20041c5076e2f87637ba5a005b0570f.png";